// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d46f523f","455":"ac9cd70b","977":"e09b525b"}[chunkId] + ".chunk.js";
};